/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsRosterListItemDtoSchema } from "./rosterListItemDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsRosterListResponseDtoSchema = z.object({
  get items() {
    return z.array(goodLuckCoreDTOsRosterListItemDtoSchema).nullish();
  },
  total: z.optional(z.int()),
  page: z.optional(z.int()),
  pageSize: z.optional(z.int()),
});
